/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable consistent-return */
import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import onClickOutside from 'react-onclickoutside';
import keydown from 'react-keydown';
import { debounce, isEqual, isEmpty, noop } from 'lodash';
import Tooltip from '@omilia/tooltip';

import { Project, Key } from 'tstypes';

import ProjectsMenuOptions from './components/ProjectsMenuOptions';

import {
  SVerticalDivider,
  SClosedSearchBarContainer,
  SCurrentProject,
  SEmptyProjectTemplate,
  SHorizontalDivider,
  SOpenedMenuHeaderContainer,
  SInnerVerticalDivider,
  SCurrentProjectName,
  SOpenArrow,
  SSettingsButton,
  SSettingsInnerMenuButton,
  SProjectsMenu,
  STextCropper,
  SOpenProjectMenuButton,
} from './styled';

interface Props {
  currentProject: Project;
  projectsAreLoading: boolean;
  history: {
    push: (param: string) => void;
  };
  keydown: Key;
  projects: Array<Project>;
  cancelGetProjectsAll: () => void;
  getProjectsAll: () => void;
  selectProject: (project: Project) => void;
}

interface State {
  isOpen: boolean;
  searchTerm: string;
}

export class ProjectsMenu extends Component<Props, State> {
  initialState = {
    isOpen: false,
    searchTerm: '',
  };

  state = this.initialState;

  debouncedGetProjectsAll = debounce(params => {
    this.props.cancelGetProjectsAll();
    this.props.getProjectsAll(params);
  }, 400);

  componentWillReceiveProps(nextProps: Props) {
    if (nextProps.keydown.event && this.state.isOpen) {
      const key = nextProps.keydown.event.which;

      if (key === 27) {
        this.handleClose();
      }
    }
  }

  handleOpen = (e: React.MouseEvent<HTMLDivElement>) => {
    e.preventDefault();

    this.setState({
      isOpen: true,
    });
  };

  handleSelectItem = (project: Project) => {
    if (isEqual(project.id, this.props.currentProject.id)) {
      this.handleClose();
      return;
    }

    this.props.selectProject(project);
    this.props.history.push(`/${project.account}/${project.slug}/entities`);

    this.handleClose();
  };

  handleChangeValue = async (value: string) => {
    const params = value ? { name__icontains: value } : {};

    await this.setState({
      searchTerm: value,
    });

    // If user will type many letters together we dont want to make multiple http requests
    // Same when user erases more than one letters.
    this.debouncedGetProjectsAll(params);
  };

  handleClickOutside = () => {
    if (this.state.isOpen) {
      this.handleClose(this.debouncedGetProjectsAll);
    }
  };

  handleClose = (cb = noop) => this.setState(this.initialState, cb);

  navigateToProjectSettings = () => {
    const { slug, account } = this.props.currentProject;

    this.props.history.push(`/${account}/${slug}/project-settings`);
  };

  handleSettingsBtnClick = () => {
    const { isOpen } = this.state;

    return isOpen
      ? this.handleClose(this.navigateToProjectSettings)
      : this.navigateToProjectSettings();
  };

  render() {
    const { searchTerm, isOpen } = this.state;
    const { projects, currentProject, projectsAreLoading } = this.props;
    const currentProjectIsEmpty = isEmpty(currentProject);

    return (
      <SProjectsMenu data-test="project-menu">
        {isOpen ? (
          <ProjectsMenuOptions
            changeValue={this.handleChangeValue}
            closePanel={this.handleClose}
            currentProject={currentProject}
            header={
              <React.Fragment>
                <SOpenedMenuHeaderContainer>
                  <div className="icon-accept" />
                  <SCurrentProjectName>
                    <STextCropper text={currentProject.name} />
                  </SCurrentProjectName>

                  <SInnerVerticalDivider />
                  <Tooltip content="Project Settings" placement="right">
                    <SSettingsInnerMenuButton
                      className="icon-application-settings"
                      data-test="project-settings-icon"
                      onClick={this.handleSettingsBtnClick}
                    />
                  </Tooltip>
                </SOpenedMenuHeaderContainer>
                <SHorizontalDivider />
              </React.Fragment>
            }
            isOpen={isOpen}
            items={projects}
            projectsAreLoading={projectsAreLoading}
            selectItem={this.handleSelectItem}
            value={searchTerm}
          />
        ) : (
          <SClosedSearchBarContainer>
            <SOpenProjectMenuButton
              data-test="open-project-menu-button"
              onClick={this.handleOpen}
            >
              <i className="icon-project" />
              <SCurrentProject data-test="current-project">
                {currentProjectIsEmpty ? (
                  <SEmptyProjectTemplate data-test="empty-project">
                    &nbsp;
                  </SEmptyProjectTemplate>
                ) : (
                  <STextCropper placement="bottom" text={currentProject.name} />
                )}
              </SCurrentProject>
              <SOpenArrow onClick={this.handleOpen} />
            </SOpenProjectMenuButton>
            <SVerticalDivider />
            <Tooltip content="Project Settings" placement="right">
              <SSettingsButton
                className="icon-application-settings"
                data-test="project-settings-icon"
                onClick={this.handleSettingsBtnClick}
              />
            </Tooltip>
          </SClosedSearchBarContainer>
        )}
      </SProjectsMenu>
    );
  }
}

export default withRouter(keydown(onClickOutside(ProjectsMenu)));
